import { useRef, useState } from "react";
import { CustomSearchBar } from "../../CustomSearchBar";
import { useQuestions } from '../../../hooks/encuestas/useQuestions';
import { makeStyles } from "@mui/styles";
import { IconButton, Tooltip } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";

export const SectionQuestions = (props) => {

    const { label, data, setValue, disabled } = props;
    const { questions } = useQuestions();
    const [filterQuestions, setFilterQuestions] = useState([]);
    const [questionsSelected, setQuestionsSelected] = useState(data || []);

    const dragQuestion = useRef(0);
    const draggedOverQuestion = useRef(0);

    const styles = useStyles();

    const searchQuestions = (value) => {
        if(value.length <= 0 || disabled)
            return setFilterQuestions([]);

        //Filtra los valores que coinciden con la busqueda
        const search = questions.filter(q => q?.codigo.includes(value.toUpperCase()) && q?.activo !== false);

        //Retorna las preguntas que no han sido seleccionadas y ordena y limpia el array de los valores en blanco
        const result = search?.map(q => questionsSelected?.every(s => q?.codigo !== s?.codigo) ? q : '')?.filter(i => i?.codigo).sort((a,b) => {
            if (a.codigo > b.codigo) return 1;
            if (a.codigo < b.codigo) return -1;
            
            return 0;
        });

        setFilterQuestions(result);
    }

    const selectedQuestions = (e) => {
        if(disabled) return;
        setFilterQuestions(filterQuestions?.filter(f => f?._id !== e?._id));
        setQuestionsSelected(prev => {
            setValue("preguntas", [...prev?.map(p => p?._id), e?._id]);
            return ([ ...prev, e ])
        });
    }

    const deleteQuestionSelected = (e) => {
        if(disabled) return;
        const filters = questionsSelected?.filter(f => f?._id !== e?._id);
        setQuestionsSelected(filters);
        setValue("preguntas", filters.map(f => f?._id));

        const response = filterQuestions.some(f => f?.codigo.charAt(0) === e?.codigo.charAt(0));
        response && setFilterQuestions(prev => ([ ...prev, e ]));
    }

    const handleQuestionSelectedSort = () => {
        const questionsSelectedClone = [ ...questionsSelected ];
        const temp = questionsSelectedClone[dragQuestion.current];
        questionsSelectedClone[dragQuestion.current] = questionsSelectedClone[draggedOverQuestion.current];
        questionsSelectedClone[draggedOverQuestion.current] = temp;
        setQuestionsSelected(questionsSelectedClone);

        setQuestionsSelected(() => {
            setValue("preguntas", [...questionsSelectedClone?.map(p => p?._id)]);
            return questionsSelectedClone
        });
    }   

    return (
        <div style={{ display: 'flex', flexFlow: 'column noWrap', gap: 5, marginBottom: 15 }}>
           { !disabled && (
                <>
                    <label style={{ fontWeight: 600, fontSize: 14 }} htmlFor="input">{ label }</label>
                    <div style={{ marginBottom: 15 }}>
                        <CustomSearchBar
                            action={ searchQuestions} 
                            placeholder='Código' 
                            disabled={ disabled }
                        />
                
                        <div style={{ display: filterQuestions?.length <= 0 ? 'none' : 'block', width: '100%', minHeight: 0, maxHeight: 100, overflowY: 'scroll', background: '#f5f5f5', borderTop: 0, borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
                            { filterQuestions.map(q => <ListItemQuestion key={ q?._id } action={ selectedQuestions } question={ q }/>) }
                        </div> 
                    </div>
                </>
            )}
            
            <>
                <label style={{ fontWeight: 600, fontSize: 14 }}>Preguntas seleccionadas</label>
                {
                    questionsSelected?.length <= 0 ? (
                        <div className={ styles.bodyQuestionsSelected }>
                            <span style={{ fontSize: 13, color: 'grey' }}>Vacio</span>
                        </div>
                    ) : (  
                        <>
                            <div style={{ border: '1px solid #bdbdbd', background: '#fff', minHeight: 100, maxHeight: 150, borderRadius: 4, overflowY: 'scroll' }}>
                                { questionsSelected?.map((s, i) => (
                                    <ListItemQuestionSelected 
                                        index={ i } 
                                        key={ s?._id } 
                                        action={ () => deleteQuestionSelected(s) } 
                                        question={ s } 
                                        disabled={ disabled } 
                                        dragQuestion={ dragQuestion } 
                                        draggedOverQuestion={ draggedOverQuestion } 
                                        onDragEnd={ handleQuestionSelectedSort }
                                    />
                                )) }
                            </div> 
                            <span style={{ fontSize: 13, color: 'grey', fontWeight: 500 }}>Total: { questionsSelected?.length }</span>
                        </>
                    )
                }
            </>
        </div>
    )
}

SectionQuestions.defaultProps = {
    label: '',
    data: [],
    setValue: () => false,
    disabled: false
}

const ListItemQuestion = (props) => {

    const { action, question } = props;
    const styles = useStyles();

    return (
        <Tooltip title={ question?.pregunta } placement="right">
            <div className={ styles.listQuestion } onClick={ () => action(question) }>
                <span style={{ fontWeight: 600, fontSize: 13 }}>{ convertirLetraMayus(question?.codigo) }</span>
                <span style={{ fontWeight: 500, fontSize: 12 }}> - { question?.pregunta.length > 50 ? convertirLetraMayus(question?.pregunta?.substring(0, 40) + '...') : convertirLetraMayus(question?.pregunta) }</span>
            </div>
        </Tooltip>
    )
}

ListItemQuestion.defaultProps = {
    action: () => false,
    question: {}
}


const ListItemQuestionSelected = (props) => {

    const { index, action, question, disabled, dragQuestion, draggedOverQuestion, onDragEnd } = props;
    const styles = useStyles();
   
    return (
        <Tooltip title={ question?.pregunta } placement="right">
            <div 
                className={ disabled ? styles.listQuestionSelectedDisabled : styles.listQuestionSelected }
                draggable
                onDragStart={ () => dragQuestion.current = index }
                onDragEnter={ () => draggedOverQuestion.current = index }
                onDragEnd={ onDragEnd }
                onDragOver={ (e) => e.preventDefault() }
            >
                <div>
                    <span style={{ fontWeight: 600, fontSize: 13, marginLeft: 10 }}>{ convertirLetraMayus(question?.codigo) }</span>
                    <span style={{ fontWeight: 500, fontSize: 12 }}> - { question?.pregunta.length > 50 ? convertirLetraMayus(question?.pregunta?.substring(0, 40) + '...') : convertirLetraMayus(question?.pregunta) }</span>
                </div>
                <IconButton onClick={ action } disabled={ disabled }>
                    <CloseOutlined htmlColor={ disabled ? 'B8B8B8' : '#00365F' } style={{ fontSize: 13 }} />
                </IconButton>
            </div>
        </Tooltip>
    )
}

ListItemQuestionSelected.defaultProps = {
    action: () => false,
    question: {},
    disabled: false
}

const useStyles = makeStyles({
    listQuestion: {
        padding: '1px 10px', 
        backgroundColor: '#fff',
        border: '1px solid #E0E0E0', 
        margin: 5, 
        borderRadius: 4,
        '&:hover': {
            background: '#00365F !important',
            color: '#fff !important',
            fontWeight: 'bold !important',
            cursor: 'pointer'
        },
        '&:active' : {
            color: '#00365F !important',
            background: '#fff !important',
            borderColor: '#00365F !important',
            cursor: 'pointer'
        }
    },

    listQuestionSelected: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#fff',
        color: '#00365F',
        border: '1.5px solid #00365F', 
        margin: 5,
        borderRadius: 4,
        cursor: 'pointer'
    },

    listQuestionSelectedDisabled: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#fff',
        color: '#B8B8B8',
        border: '1.5px solid #B8B8B8', 
        margin: 5,
        borderRadius: 4,
    },

    bodyQuestionsSelected : {
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        border: '1px solid #bdbdbd', 
        background: '#fff', 
        minHeight: 100, 
        maxHeight: 150, 
        borderRadius: 4, 
        overflowY: 'scroll'
    }
});